<template>
  <div>
    <h2>Create a stock pattern</h2>
    <div class="flex flex-col sm:flex-row flex-wrap">
      <div class="w-full sm:w-1/2 flex-col">
        <div class="mb-2 sm:mb-4 p-1">
          <div class="flex items-center border-b border-b-2 border-blue-darker pt-2">
            <input :value="ticker" class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2 leading-tight" type="text" placeholder="Ticker" aria-label="Full name" maxlength="6" @input="ticker = $event.target.value.toUpperCase()">
          </div>
        </div>
        <div class="mb-2 sm:mb-4 flex">
          <div class="relative w-full p-2">
            <select id="grid-state" v-model="pattern" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded leading-tight">
              <option value="null" disabled>Stock Pattern</option>
              <option v-for="(pattern, index) in patterns" :value="pattern" :key="index">
                {{ pattern }}
              </option>
            </select>
            <div class="pointer-events-none absolute pin-y pin-r flex items-center px-4 text-grey-darker">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
          <img :src="patternImage" width="26" class="self-center ml-3 mr-3">
        </div>
      </div>
      <div class="flex-col w-full sm:w-1/2 pl-0 sm:pl-5">
        <h4 class="mb-2">Note:</h4>
        <textarea v-model="note" class="w-full border rounded-lg" rows="6"></textarea>
        <div class="flex justify-end mt-2">
          <button :class="buttonState" class="flex-no-shrink bg-blue-dark hover:bg-blue-darker border-blue-dark hover:border-blue-darker text-sm border-4 text-white py-1 px-2 rounded" type="button" @click="createPattern()">
            Create
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "arctic-vuejs-template";

export default {
  name: "stock-pattern-create",
  data() {
    return {
      note: null,
      patterns: [
        "Rolling Stock",
        "Up Trend",
        "Down Trend",
        "Stair Steps",
        "Flag Pattern",
        "Flat Base",
        "Cup & Handle",
        "Saucer & Handle",
        "Kiss Goodbye",
        "'W'",
        "'M'",
        "Head & Shoulders"
      ],
      saving: false,
      pattern: null,
      ticker: null
    };
  },
  computed: {
    buttonState() {
      if (!this.canSave || this.saving) {
        return [
          "cursor-not-allowed",
          "opacity-50",
          "hover:bg-blue-dark",
          "hover:border-blue-dark"
        ];
      }
      return {};
    },
    canSave() {
      if (!this.ticker || !this.pattern) return false;
      return true;
    },
    patternImage() {
      if (!this.pattern) return null;
      return (
        "/img/" +
        this.pattern
          .replace(/\W+/g, "_")
          .replace(/-$/g, "")
          .toLowerCase() +
        ".png"
      );
    }
  },
  methods: {
    createPattern() {
      if (this.saving) return;
      this.saving = true;
      api
        .post("/pattern", {
          ticker: this.ticker,
          pattern: this.pattern,
          note: this.note
        })
        .then(() => this.$router.push("/stock-patterns"));
    }
  }
};
</script>
